import { createStyles } from "@material-ui/core";
import AreaNormalRegular from "fonts/AreaJPNormal-Regular.woff2";
import AreaNormalBold from "fonts/AreaJPNormal-Bold.woff2";
import TransducerBold from "fonts/Transducer-Bold.woff2";
export var styles = function (_a) {
    var _b;
    var breakpoints = _a.breakpoints;
    return createStyles({
        "@global": {
            "@font-face": [
                {
                    fontFamily: "'Area Normal'",
                    fontWeight: 400,
                    fontStyle: "normal",
                    src: "url(" + AreaNormalRegular + ") format('woff2')"
                },
                {
                    fontFamily: "'Area Normal'",
                    fontWeight: 700,
                    fontStyle: "normal",
                    src: "url(" + AreaNormalBold + ") format('woff2')"
                },
                {
                    fontFamily: "'Transducer VF'",
                    fontWeight: 700,
                    fontStyle: "normal",
                    src: "url(" + TransducerBold + ") format('woff2')"
                }
            ],
            "html, body, #root": {
                margin: 0,
                padding: 0,
                height: "100%"
            }
        },
        root: (_b = {
                display: "flex",
                minHeight: "100vh",
                alignItems: "center",
                justifyContent: "center",
                background: "linear-gradient(78.6deg, #FFF7F5 1.46%, #EBE4FF 71.39%, #F8F6FF 97.4%)",
                position: "relative",
                overflow: "hidden",
                "& > *": {
                    position: "relative",
                    zIndex: 1
                }
            },
            _b[breakpoints.down("xs")] = {
                alignItems: "initial"
            },
            _b)
    });
};
